import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/pro-light-svg-icons';
import { assessmentBadges } from '../Review/Badges';
import RinggoldBadge from '../RinggoldBadge';
import { useAdjudicationData } from 'src/contexts/AdjudicationDataProvider';
import FileComponent from '../Assessment/FileComponent';
import { useOptInsData } from 'src/pages/MyTask/Assessments/hooks';
import AssessmentFeedbackAccordion from '../Assessment/AssessmentFeedbackAccordian';
import { IAdjudicationFormSubmission } from '@publishing-engine/domain/models';

interface Props {
  onClose: () => void;
  isOpen: boolean;
}

const ReviewFeedbackModal = ({ onClose, isOpen }: Props) => {
  const { adjudication, workflowResponse } = useAdjudicationData();
  const { config, isOptIns } = useOptInsData(workflowResponse, adjudication.submissionContextId)
  const submissionScore = adjudication?.caseData.adjudication?.submissionScores;

  const additionalReference = adjudication?.caseData?.adjudication?.missingReference

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="45rem"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <Flex flexDirection="column" gap={4}>
          <FontAwesomeIcon
            icon={faComment}
            style={{ width: '40px', height: '40px' }}
          />
          <Text textStyle="headingGroup">Review Feedback</Text>
          {adjudication.caseData.adjudication?.recommendation && (
            <Flex flexDirection="column" gap={3}>
              <Text textStyle="headingGroup">Recommendation</Text>
              <Flex>
                {
                  assessmentBadges[
                  adjudication.caseData.adjudication.recommendation
                  ]
                }
              </Flex>
            </Flex>
          )}
        </Flex>
        {isOptIns && adjudication.caseData.adjudication && submissionScore ?
          <AssessmentFeedbackAccordion
            assessment={adjudication.caseData.adjudication as IAdjudicationFormSubmission}
            config={config}
            submissionScore={submissionScore}
            additionalReference={additionalReference}
          />
          :

          <Flex flexDirection="column" gap={6}>
            {(adjudication.caseData.adjudication?.feedbackForEditors || (adjudication.caseData.adjudication?.editorAttachments && adjudication.caseData.adjudication?.editorAttachments?.length > 0)
              || adjudication.caseData.adjudication?.recommendedReviewers?.exists) &&
              <>
                <Text textStyle="headingGroup">Communications For Editors</Text>
                {adjudication.caseData.adjudication?.feedbackForEditors &&
                  <Flex gap={3} direction={'column'}>
                    <Text textStyle="headingItem">Feedback for Editors</Text>
                    <Text textStyle="textBody">
                      {adjudication.caseData.adjudication?.feedbackForEditors}
                    </Text>
                  </Flex>}

                {adjudication.caseData.adjudication?.editorAttachments && adjudication.caseData.adjudication?.editorAttachments?.length > 0 && (
                  <Flex flexDirection="column" gap={3}>
                    <Text textStyle={'headingItem'}>Attached Files</Text>
                    {adjudication.caseData.adjudication?.editorAttachments.map(file => (
                      <FileComponent file={file} />
                    ))}
                  </Flex>
                )}
                {adjudication.caseData.adjudication?.recommendedReviewers
                  ?.exists && (
                    <><Text textStyle="headingItem">Recommended Reviewers</Text>
                      {adjudication.caseData.adjudication?.recommendedReviewers?.value.map(
                        item => (
                          <Flex flexDirection="column" gap={2}>
                            <Text textStyle="headingItem">
                              {item.firstName} {item.lastName}
                            </Text>
                            <Flex gap={1} alignItems="center">
                              <Text
                                noOfLines={1}
                                overflow="hidden"
                                textOverflow="ellipsis"
                              >
                                {item.affiliation}
                              </Text>
                              {item.ringgoldId && <RinggoldBadge />}
                            </Flex>
                            <Text textStyle="textBody">{item.email}</Text>
                            <Text textStyle="textBody">{item.reason}</Text>
                          </Flex>
                        )
                      )}
                    </>
                  )}

              </>}

            {(adjudication.caseData.adjudication?.feedbackForAuthors || (adjudication.caseData.adjudication?.authorsAttachments && adjudication.caseData.adjudication?.authorsAttachments?.length > 0)) && (
              <>
                <Text textStyle="headingGroup">Communications For Authors</Text>
                {adjudication.caseData.adjudication?.feedbackForAuthors && <Flex gap={3} direction={'column'}>
                  <Text textStyle="headingItem">Feedback for Authors</Text>
                  <Text textStyle="textBody">
                    {adjudication.caseData.adjudication?.feedbackForAuthors}
                  </Text>
                </Flex>}
                {adjudication.caseData.adjudication?.authorsAttachments && adjudication.caseData.adjudication?.authorsAttachments?.length > 0 && (
                  <Flex flexDirection="column" gap={3}>
                    <Text textStyle={'headingItem'}>Attached Files</Text>
                    {adjudication.caseData.adjudication?.authorsAttachments.map(file => (
                      <FileComponent file={file} />
                    ))}
                  </Flex>
                )}
              </>
            )}
          </Flex>
        }

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ReviewFeedbackModal;
